import React from "react";
import PropTypes from "prop-types";
import MessageBanner, { TYPE_ERROR, TYPE_SUCCESS } from '../elements/banner/MessageBanner';
import { EMAIL_VERIFICATION_STATUS_UNVERIFIED, EMAIL_VERIFICATION_STATUS_VERIFIED, EMAIL_VERIFICATION_STATUS_VERIFIED_BEFORE } from '../../constants/user';

export default class VerificationStatus extends React.PureComponent {
    state = {
        isClosed: false,
    };
    componentDidMount() {

    }

    onCloseCallback = () => {
        this.setState({
            isClosed: true,
        })
    };
    render() {
        let { isClosed } = this.state;

        if (isClosed) {
            return false;
        }

        let { isScreenLoader, verificationStatus } = this.props;

        if (isScreenLoader || ![EMAIL_VERIFICATION_STATUS_UNVERIFIED, EMAIL_VERIFICATION_STATUS_VERIFIED, EMAIL_VERIFICATION_STATUS_VERIFIED_BEFORE].includes(verificationStatus)) {
            return false;
        }

        const className = 'verification-status';

        switch (verificationStatus) {
            case EMAIL_VERIFICATION_STATUS_UNVERIFIED:
                return <MessageBanner className={className} onCloseCallback={this.onCloseCallback} type={TYPE_ERROR}>Your account cannot be verified</MessageBanner>;
            default:
                return <MessageBanner className={className} onCloseCallback={this.onCloseCallback} type={TYPE_SUCCESS}>Your account has been verified <span role="img" aria-label={'peace'}>✌</span>️</MessageBanner>;
        }
    }
}

VerificationStatus.propTypes = {
    isScreenLoader: PropTypes.bool.isRequired,
    verificationStatus: PropTypes.number,
    setVerificationStatus: PropTypes.func.isRequired,
};
